// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__A7RKb","rotate":"Spinner_rotate__HmaI4","dash":"Spinner_dash__1NmoU","overlay":"Spinner_overlay__YGs0Y","bluredOverlay":"Spinner_bluredOverlay__lZOIl"};